import { MdOutlineLogout as LogoutIcon } from 'react-icons/md';
import { ACCESS_RIGHTS, COMPANY_TYPES } from './enums';
import { MdOutlineDashboard } from "react-icons/md";
import { IoWalletOutline } from "react-icons/io5";
import { GiTakeMyMoney } from "react-icons/gi";
import { PiUsersThree } from "react-icons/pi";
import { IoIosGitBranch } from "react-icons/io";
import { IoSettingsOutline } from "react-icons/io5";
import { MdOutlineHomeWork } from "react-icons/md";
import { LiaPeopleCarrySolid } from "react-icons/lia";
import { FaHandHoldingUsd } from "react-icons/fa";
import { GiCash } from "react-icons/gi";
import { sidebarCategory } from './types';
import { GrMoney } from "react-icons/gr";
import { LuBriefcaseMedical } from "react-icons/lu";
import { SlBookOpen } from "react-icons/sl";
import { GiMoneyStack } from "react-icons/gi";
import { TbReportAnalytics } from "react-icons/tb";
import { TbCashRegister } from "react-icons/tb";

export const PERSISTENT_STORAGE_KEY = 'adm-k89';

export const SIDE_BAR_NAVS: Record<sidebarCategory, any> = {
  dashboard: [
    {
      title: 'Home',
      path: '/dashboard',
      icon: MdOutlineDashboard,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.ADMIN,
        ACCESS_RIGHTS.AGENT,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'home'
    },
    {
      title: 'Reports',
      path: '/reports',
      icon: TbReportAnalytics,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.ADMIN,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'reports'
    },
  ],
  accounts: [
    {
      title: 'Accounts',
      path: '/accounts',
      icon: IoWalletOutline,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.ADMIN,
        ACCESS_RIGHTS.AGENT,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'accounts'
    },
    {
      title: 'Transactions',
      path: '/transactions',
      icon: GiTakeMyMoney,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.ADMIN,
        ACCESS_RIGHTS.AGENT,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'transactions'
    },
    {
      title: 'Customers',
      path: '/customers',
      icon: PiUsersThree,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.ADMIN,
        ACCESS_RIGHTS.AGENT,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'customers'
    },
    {
      title: 'Reconciliations',
      path: '/reconciliations',
      icon: FaHandHoldingUsd,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.MANAGER,
        ACCESS_RIGHTS.ADMIN,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'reconciliation'
    },
    {
      title: 'Passbook Sales',
      path: '/passbooks',
      icon: SlBookOpen,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.ADMIN,
        ACCESS_RIGHTS.AGENT,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'passbooks'
    },
  ],
  financing: [
    {
      title: 'Loans',
      path: '/financing/loans',
      icon: GiCash,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.ADMIN,
        ACCESS_RIGHTS.AGENT,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'loans'
    },
    {
      title: 'Loan Calculator',
      path: '/financing/loans/calculate',
      icon: LuBriefcaseMedical,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.ADMIN,
        ACCESS_RIGHTS.AGENT,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'loan-calculator'
    },
    // {
    //   title: 'Loan Products',
    //   path: '/financing/loan-products',
    //   icon: GrMoney,
    //   access: [
    //     ACCESS_RIGHTS.OWNER,
    //     COMPANY_TYPES.INTERNAL,
    //     COMPANY_TYPES.SUSU
    //   ],
    //   key: 'loan-products'
    // },
    {
      title: 'Hire Purchase',
      path: '/financing/hire-purchases',
      icon: TbCashRegister,
      access: [
        ACCESS_RIGHTS.OWNER,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'hire-purchases'
    },
  ],
  manage: [
    {
      title: 'Companies',
      path: '/companies',
      icon: MdOutlineHomeWork,
      access: [
        ACCESS_RIGHTS.OWNER,
        COMPANY_TYPES.INTERNAL
      ],
      key: 'companies'
    },
    {
      title: 'Agents',
      path: '/agents',
      icon: LiaPeopleCarrySolid,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.MANAGER,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'agents'
    },
    // {
    //   title: 'Branches',
    //   path: '/branches',
    //   icon: IoIosGitBranch,
    //   access: [
    //     ACCESS_RIGHTS.OWNER,
    //     ACCESS_RIGHTS.MANAGER,
    //     COMPANY_TYPES.INTERNAL,
    //     COMPANY_TYPES.SUSU
    //   ],
    //   key: 'branches'
    // },
    {
      title: 'Revenues',
      path: '/revenues',
      icon: GiMoneyStack,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.MANAGER,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'revenues'
    }
  ],
  system: [
    {
      title: 'Settings',
      path: '/settings',
      icon: IoSettingsOutline,
      access: [
        ACCESS_RIGHTS.OWNER,
        ACCESS_RIGHTS.ADMIN,
        ACCESS_RIGHTS.AGENT,
        COMPANY_TYPES.INTERNAL,
        COMPANY_TYPES.SUSU
      ],
      key: 'settings'
    }
    // {
    //   title: 'Log out',
    //   path: '/settings',
    //   icon: LogoutIcon,
    //   access: [
    //     ACCESS_RIGHTS.OWNER,
    //     ACCESS_RIGHTS.ADMIN,
    //     ACCESS_RIGHTS.AGENT
    //   ],
    //   key: 'settings'
    // }
  ]
};

export const GHANA_REGIONS = [
  'Ahafo',
  'Ashanti',
  'Bono East',
  'Brong Ahafo',
  'Central',
  'Eastern',
  'Greater-Accra',
  'Western',
  'Western North',
  'Northern',
  'North-East',
  'Oti',
  'Savannah',
  'Upper East',
  'Upper West',
  'Volta'
];

export const SERVER_DATE_FORMAT = 'YYYY-MM-DD hh:mm:ss';

export const INPUT_DATE_FORMAT = 'YYYY-MM-DD';

export const OCCUPATION_TYPES: Record<string, { title: string; description: string }> = {
  MINING_AND_ENGINEERING: {
    title: 'Mining and Engineering',
    description: ''
  },
  UNEMPLOYED: {
    title: 'Unemployed',
    description: ''
  },
  COMMERCIAL_DRIVER: {
    title: 'Commercial Driver',
    description: ''
  },
  SELF_EMPLOYED: {
    title: 'Self Employed',
    description: ''
  },
  SALESPERSON: {
    title: 'Sales Person',
    description: ''
  },
  HEALTH_WORKER: {
    title: 'Health Worker',
    description: ''
  },
  SECURITY_SERVICES: {
    title: 'Security Services',
    description: ''
  },
  TRAVEL_AGENT: {
    title: 'Travel Agent',
    description: ''
  },
  ANY_OTHER_PROFESSION: {
    title: 'Any Other Profession',
    description: ''
  },
  BUSINESS_EXECUTIVE: {
    title: 'Business Executive',
    description: ''
  }
};
export const libraries: Array<'drawing' | 'places' | 'geometry'> = [
  'drawing',
  'places',
  'geometry'
];

export const BANKS_OF_GHANA = [
  'Absa Bank Ghana Limited',
  'Access Bank Ghana Plc',
  'Agricultural Development Bank of Ghana',
  'Bank of Africa Ghana Limited',
  'CalBank Limited',
  'Consolidated Bank Ghana Limited',
  'Ecobank Ghana Limited',
  'FBN Bank Ghana Limited',
  'Fidelity Bank Ghana Limited',
  'First Atlantic Bank Limited',
  'First National Bank Ghana',
  'GCB Bank Limited',
  'Guaranty Trust Bank Ghana Limited',
  'National Investment Bank Limited',
  'OmniBSIC Bank Ghana Limited',
  'Prudential Bank Limited',
  'Republic Bank Ghana Limited',
  'Société Générale Ghana Limited',
  'Stanbic Bank Ghana Limited',
  'Standard Chartered Bank Ghana Limited',
  'United Bank for Africa Ghana Limited',
  'Universal Merchant Bank Limited',
  'Zenith Bank Ghana Limited.'
];

export const COUNTRY_OPTIONS = ['Ghana'];

export const MONTHS_OF_THE_YEAR = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const AccountsDonutsBgColors = ['#FACC15', '#14B8A6', '#3B82F6', '#6366F1', '#F59E0B'];

export const NUMBER_INPUT_PATTERN = "d*";

export const PHONE_INPUT_COUNTRIES = ["GH", "US", "GB"]

export const CEDI_SIGN = `₵`;

export const BG_COLORS = [
  "bg-blue-500",
  "bg-green-500",
  "bg-purple-500"
]

